// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__c5Egg","container":"styles_container__S5HKC","noMargin":"styles_noMargin__RaN1X"};